import type { RouteObject } from "react-router-dom";
import NotFound from "@/pages/NotFound";
import Layout from "@/components/feature/Layout";
import HomePage from "@/pages/home/page";
import EventsPage from "@/pages/events/page";
import EventDetailPage from "@/pages/event/detail";
import AboutPage from "@/pages/about/page";
import FaqPage from "@/pages/faq/page";

const routes: RouteObject[] = [
  {
    element: <Layout />,
    children: [
      { path: "/", element: <HomePage /> },
      { path: "/events", element: <EventsPage /> },
      { path: "/event/:id", element: <EventDetailPage /> },
      { path: "/about", element: <AboutPage /> },
      { path: "/faq", element: <FaqPage /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;